import { getNodeDimensions } from './constants';
import { getMilestoneLayoutDims, isMilestoneNode } from '../utils/milestoneUtils';
import { getNoteLayoutDims, isNoteNode } from '../utils/noteUtils';

/**
 * Seed note / milestone default footprints so packing, bbox, and sync layout
 * use the same sizes ELK already uses — not the 290×150 mission fallback.
 */
export function withLayoutDimensionDefaults(tasks, nodeDimensions = {}) {
  const next = { ...nodeDimensions };
  (tasks || []).forEach((task) => {
    const existing = next[task.id];
    if (existing?.width && existing?.height) return;
    if (isNoteNode(task)) {
      next[task.id] = getNoteLayoutDims(nodeDimensions, task.id);
    } else if (isMilestoneNode(task)) {
      next[task.id] = getMilestoneLayoutDims(nodeDimensions, task.id);
    } else {
      next[task.id] = getNodeDimensions(task.id, nodeDimensions);
    }
  });
  return next;
}
